import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { FormattedMessage } from 'ui/i18n';

import './NavigationPrompt.scss';

class NavigationPrompt extends React.Component {
	static propTypes = {
		history: PropTypes.object.isRequired,
		when: PropTypes.bool.isRequired,
	};

	constructor(props) {
		super(props);
		this.state = { nextLocation: null, openModal: false };
		this.handleOnCancel = this.handleOnCancel.bind(this);
		this.handleOnConfirm = this.handleOnConfirm.bind(this);
	}

	componentDidMount() {
		this.unblock = this.props.history.block(nextLocation => {
			if (this.props.when) {
				this.setState({
					openModal: true,
					nextLocation,
				});
			}
			return !this.props.when;
		});
	}

	componentWillUnmount() {
		this.unblock();
	}

	handleOnCancel() {
		this.navigateToNextLocation();
	}

	handleOnConfirm() {
		this.setState({ nextLocation: null, openModal: false });
	}

	navigateToNextLocation() {
		if (
			this.props.history.location.pathname === this.state.nextLocation.pathname
		) {
			this.setState({ openModal: false });
		} else {
			this.unblock();
			this.props.history.push(
				this.state.nextLocation.pathname + this.state.nextLocation.search
			);
		}
	}

	render() {
		return (
			<Modal
				className="ReactModal__Content NavigationPrompt"
				id="NavigationPromptModal"
				overlayClassName="ReactModal__Overlay"
				isOpen={this.state.openModal}
				contentLabel="Navigate Away"
			>
				<h4>
					<strong>
						<FormattedMessage id="cart.leaveCartTitle" />
					</strong>
				</h4>
				<hr />
				<h5 id="LeaveCartMessage">
					<FormattedMessage id="cart.leaveCartMessage" />
				</h5>

				<div className="row NavigationPrompt-footer">
					<div className="pull-right">
						<button
							className="btn btn-primary"
							id="NavigationPrompt-footer-button-primary"
							onClick={this.handleOnConfirm}
						>
							OK
						</button>
						<button
							className="btn btn-primary"
							id="NavigationPrompt-footer-button-secondary"
							onClick={this.handleOnCancel}
						>
							<FormattedMessage id="general.cancelText" />
						</button>
					</div>
				</div>
			</Modal>
		);
	}
}

export default withRouter(NavigationPrompt);



// WEBPACK FOOTER //
// ./src/ui/components/NavigationPrompt/index.js